import React, { useState } from 'react';
import {
  Box, Typography, useMediaQuery, useTheme,
} from '@mui/material';
import StyledBox, {
  StyledCarousel,
  StyledImgBox,
} from 'views/experience-module/MotorcycleTripView/components/MotorcycleRentalsSection/MotorcycleRentalsSection.styles';
import Typography500 from 'views/common/components/UI/Typography500/Typography500';
import { useSelector } from 'react-redux';
import { MakeCarousel } from 'views/experience-module/MotorcycleTripView/components/MakeCarousel/MakeCarousel';
import { Typography700 } from 'views/common/components';

const responsive = (itemsLength) => ({
  superLargeDesktop: {
    breakpoint: { max: 4000, min: 1300 },
    items: 4,
    partialVisibilityGutter: 0, // this is needed to tell the amount of px that should be visible.
  },
  desktop: {
    breakpoint: { max: 1300, min: 1025 },
    items: 4,
    partialVisibilityGutter: 0,
  },
  tablet: {
    breakpoint: { max: 1025, min: 600 },
    items: 2,
    partialVisibilityGutter: itemsLength <= 2 ? 0 : 70,
  },
  mobile: {
    breakpoint: { max: 600, min: 0 },
    items: 1,
    partialVisibilityGutter: 100,
    arrow: false,
  },
});
const MotorcycleRentalsSection = (props) => {
  const { title, description, motorcycleRentals = [] } = props;
  const { isCrawler, deviceType } = useSelector((state) => state.globalData);
  const theme = useTheme();
  const isTablet = useMediaQuery(theme.breakpoints.down('lg'));
  const [selectedVehicleModels, setSelectedVehicleModels] = useState(
    motorcycleRentals[0]?.vehicle_models || [],
  );
  const [mountCarousel, setMountCarousel] = useState(true);
  const handleVehicleMakeChange = (id) => {
    const selectedVModels = motorcycleRentals.find((vm) => vm.id === id)?.vehicle_models || [];
    setSelectedVehicleModels(selectedVModels);
    setMountCarousel(false);
    setTimeout(() => setMountCarousel(true), 0);
  };

  return (
    <StyledBox>
      <Typography500 variant="h3">{title}</Typography500>
      <Typography variant="body2">{description}</Typography>
      <MakeCarousel
        makesRentals={motorcycleRentals}
        handleVehicleMakeChange={handleVehicleMakeChange}
      />
      {mountCarousel ? (
        <StyledCarousel
          partialVisible={selectedVehicleModels.length != 1}
          swipeable
          draggable={false}
          ssr={isCrawler}
          deviceType={deviceType}
          keyBoardControl
          arrows={!isTablet}
          autoPlay={false}
          showDots={isTablet}
          shouldResetAutoplay={false}
          containerClass="carousel-container"
          customTransition="transform 200ms ease-in"
          responsive={responsive(selectedVehicleModels.length)}>
          {selectedVehicleModels.map((item) => (
            <Box key={item.id} className="MRSCarouselItem">
              <StyledImgBox
                imgWidth="auto"
                imgHeight="11.25rem"
                image={{
                  src: item.image.large_url,
                  alt: `${item.display_name} Rentals`,
                }}
                imgObjectFit="contain"
              />
              <Typography700
                textAlign="center"
                variant="h5"
                component="p"
                mt={1}>
                {item.display_name}
              </Typography700>
            </Box>
          ))}
        </StyledCarousel>
      ) : (
        <Box height={{ lg: 214, md: 214, sm: 178 }} />
      )}
    </StyledBox>
  );
};
export { MotorcycleRentalsSection };
